/* Theme JS logic for LumioraHome - Shopify Cart & Checkout Integration */
document.addEventListener('DOMContentLoaded', () => {
  // Safe helper to build Shopify API URLs
  function getCartEndpoint(path) {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + path.replace(/^\//, '');
    }
    return '/' + path.replace(/^\//, '');
  }

  // Check if running on live Shopify store vs local preview
  function isShopifyEnvironment() {
    return Boolean(window.Shopify && window.Shopify.shop);
  }

  // Local static preview cart data dictionary
  const LOCAL_VARIANTS = {
    '1': {
      id: '1',
      title: 'Kit Completo (Sérum + Contorno)',
      sub: 'Sérum pump 30ml + Tubo precisión 15ml',
      price: 39.95,
      formattedPrice: '€39,95',
      image: './assets/botes_juntos_primer_plano.png'
    },
    '2': {
      id: '2',
      title: '1x Crema Contorno (15ML)',
      sub: 'Tratamiento focalizado para ojeras',
      price: 19.95,
      formattedPrice: '€19,95',
      image: './assets/crema_1_ud.png'
    },
    '3': {
      id: '3',
      title: '1x Sérum Facial (30ML)',
      sub: 'Dosis diaria antiarrugas global',
      price: 24.95,
      formattedPrice: '€24,95',
      image: './assets/serum_1_ud.png'
    }
  };

  // Local Storage Cart for Preview Mode
  let localCart = [];
  try {
    const saved = localStorage.getItem('lumiora_local_cart');
    if (saved) localCart = JSON.parse(saved);
  } catch (e) {
    localCart = [];
  }

  function saveLocalCart() {
    try {
      localStorage.setItem('lumiora_local_cart', JSON.stringify(localCart));
    } catch (e) {}
  }

  // Gallery Thumbnail Switcher
  const mainImg = document.getElementById('MtMainImg');
  const thumbs = document.querySelectorAll('.mt-thumb');

  function setProductImage(newSrc) {
    if (!mainImg || !newSrc) return;
    mainImg.src = newSrc;

    let matched = false;
    thumbs.forEach(thumb => {
      const thumbSrc = thumb.getAttribute('data-img-src');
      if (thumbSrc && (thumbSrc === newSrc || newSrc.endsWith(thumbSrc) || thumbSrc.endsWith(newSrc))) {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        matched = true;
      }
    });

    if (!matched) {
      thumbs.forEach(t => t.classList.remove('is-active'));
    }
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const newSrc = thumb.getAttribute('data-img-src');
      if (mainImg && newSrc) {
        mainImg.src = newSrc;
      }
    });
  });

  // Price Option / Variant Selector
  const priceOptions = document.querySelectorAll('.mt-price-option, .mt-price-option-cream');
  const variantInput = document.getElementById('SelectedVariantId');
  const quantityInput = document.getElementById('SelectedQuantity');
  const cremaSelect = document.getElementById('CremaUnitSelect');

  priceOptions.forEach(option => {
    option.addEventListener('click', (e) => {
      if (e.target.tagName === 'SELECT') return;

      priceOptions.forEach(o => o.classList.remove('is-selected'));
      option.classList.add('is-selected');

      if (option.classList.contains('mt-price-option-cream') && cremaSelect) {
        const selectedOpt = cremaSelect.options[cremaSelect.selectedIndex];
        if (variantInput && selectedOpt) variantInput.value = selectedOpt.value;
        if (quantityInput && selectedOpt) quantityInput.value = selectedOpt.getAttribute('data-qty') || 1;

        const imgSrc = selectedOpt.getAttribute('data-img-src') || option.getAttribute('data-img-src');
        setProductImage(imgSrc);
      } else {
        const variantId = option.getAttribute('data-variant-id');
        if (variantInput && variantId) variantInput.value = variantId;
        if (quantityInput) quantityInput.value = 1;

        const imgSrc = option.getAttribute('data-img-src');
        setProductImage(imgSrc);
      }
    });
  });

  if (cremaSelect) {
    cremaSelect.addEventListener('change', () => {
      priceOptions.forEach(o => o.classList.remove('is-selected'));
      const creamCard = document.querySelector('.mt-price-option-cream');
      if (creamCard) creamCard.classList.add('is-selected');

      const selectedOpt = cremaSelect.options[cremaSelect.selectedIndex];
      if (variantInput && selectedOpt) variantInput.value = selectedOpt.value;
      if (quantityInput && selectedOpt) quantityInput.value = selectedOpt.getAttribute('data-qty') || 1;

      const imgSrc = selectedOpt.getAttribute('data-img-src') || (creamCard ? creamCard.getAttribute('data-img-src') : null);
      setProductImage(imgSrc);
    });
  }

  // Cart Drawer Elements & Toggle
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartDrawerOverlay');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-active');
    if (cartOverlay) cartOverlay.classList.add('is-active');
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-active');
    if (cartOverlay) cartOverlay.classList.remove('is-active');
  }

  // Attach Open Event: select header cart button but exclude close button
  const openBtns = document.querySelectorAll('[data-cart-open], [data-cart-toggle], .site-header__cart-btn:not([data-cart-close])');
  openBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  });

  // Attach Close Events
  document.querySelectorAll('[data-cart-close]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeCart();
    });
  });

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCart);
  }

  // Update Header Badges
  function updateBadges(count) {
    const badges = document.querySelectorAll('.cart-count-badge, .cart-count-badge-text');
    badges.forEach(b => {
      b.textContent = count;
    });
  }

  // Local Preview Cart Drawer Renderer
  function renderLocalCart() {
    const drawerContent = document.querySelector('.cart-drawer__content');
    const drawerFooter = document.querySelector('.cart-drawer__footer');
    if (!drawerContent) return;

    let totalItems = 0;
    let totalPrice = 0;

    localCart.forEach(item => {
      totalItems += item.quantity;
      const variantData = LOCAL_VARIANTS[item.id] || {
        title: 'Producto Lumiora',
        sub: '',
        price: 39.95,
        formattedPrice: '€39,95',
        image: './assets/botes_juntos_primer_plano.png'
      };
      totalPrice += variantData.price * item.quantity;
    });

    updateBadges(totalItems);

    if (localCart.length === 0) {
      drawerContent.innerHTML = `
        <div class="cart-drawer__empty">
          <div class="cart-drawer__empty-title">Tu carrito está vacío</div>
          <div class="cart-drawer__empty-sub">Añade tus productos favoritos para comenzar la compra.</div>
          <button type="button" class="mt-add-cart-btn" data-cart-close style="display: inline-block; width: auto; padding: 12px 24px;">
            Seguir comprando
          </button>
        </div>
      `;
      if (drawerFooter) drawerFooter.style.display = 'none';

      // Re-bind close button inside empty state
      drawerContent.querySelectorAll('[data-cart-close]').forEach(btn => {
        btn.addEventListener('click', closeCart);
      });
      return;
    }

    let itemsHtml = '<div class="cart-drawer__items">';
    localCart.forEach((item, index) => {
      const v = LOCAL_VARIANTS[item.id] || {
        title: 'Producto Lumiora',
        sub: '',
        price: 39.95,
        formattedPrice: '€39,95',
        image: './assets/botes_juntos_primer_plano.png'
      };
      const itemSubtotal = (v.price * item.quantity).toFixed(2).replace('.', ',');

      itemsHtml += `
        <div class="cart-item" data-variant-id="${item.id}">
          <img src="${v.image}" alt="${v.title}" class="cart-item__img" width="64" height="64">
          <div class="cart-item__details">
            <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;">
              <h4 class="cart-item__title">${v.title}</h4>
              <button type="button" class="cart-item__remove-btn" data-local-remove="${index}" aria-label="Eliminar producto">✕</button>
            </div>
            <p class="cart-item__variant">${v.sub}</p>
            <div class="cart-item__price-qty">
              <span class="cart-item__price">€${itemSubtotal}</span>
              <div class="cart-item__qty-selector">
                <button type="button" class="cart-item__qty-btn" data-local-qty="${index}" data-change="-1" aria-label="Reducir cantidad">-</button>
                <span class="cart-item__qty-val">${item.quantity}</span>
                <button type="button" class="cart-item__qty-btn" data-local-qty="${index}" data-change="1" aria-label="Aumentar cantidad">+</button>
              </div>
            </div>
          </div>
        </div>
      `;
    });
    itemsHtml += '</div>';

    drawerContent.innerHTML = itemsHtml;

    if (drawerFooter) {
      drawerFooter.style.display = 'block';
      const formattedTotal = '€' + totalPrice.toFixed(2).replace('.', ',');
      const subtotalEl = drawerFooter.querySelector('.cart-drawer__subtotal, span:nth-child(2)');
      if (subtotalEl) subtotalEl.textContent = formattedTotal;
    }

    // Attach local quantity and remove handlers
    drawerContent.querySelectorAll('[data-local-remove]').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.getAttribute('data-local-remove'), 10);
        localCart.splice(idx, 1);
        saveLocalCart();
        renderLocalCart();
      });
    });

    drawerContent.querySelectorAll('[data-local-qty]').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.getAttribute('data-local-qty'), 10);
        const change = parseInt(btn.getAttribute('data-change'), 10);
        if (localCart[idx]) {
          localCart[idx].quantity += change;
          if (localCart[idx].quantity <= 0) {
            localCart.splice(idx, 1);
          }
          saveLocalCart();
          renderLocalCart();
        }
      });
    });
  }

  // Refresh Cart Drawer (Live Shopify Store)
  async function refreshShopifyCart() {
    try {
      const res = await fetch(getCartEndpoint('cart.js'));
      const cart = await res.json();
      updateBadges(cart.item_count);

      const secRes = await fetch(window.location.pathname + '?section_id=cart-drawer');
      const secText = await secRes.text();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = secText;

      const newDrawer = tempDiv.querySelector('#CartDrawer');
      if (newDrawer && cartDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
        bindCartDrawerEvents();
      }
    } catch (err) {
      console.warn('Could not refresh Shopify cart:', err);
    }
  }

  function bindCartDrawerEvents() {
    if (!cartDrawer) return;

    // Close button
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(btn => {
      btn.addEventListener('click', closeCart);
    });

    // Quantity change buttons in live Shopify
    cartDrawer.querySelectorAll('[data-cart-change]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = btn.getAttribute('data-line');
        const qty = btn.getAttribute('data-qty');
        try {
          await fetch(getCartEndpoint('cart/change.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
          });
          await refreshShopifyCart();
        } catch (err) {
          console.error('Error changing cart quantity:', err);
        }
      });
    });

    // Remove buttons in live Shopify
    cartDrawer.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = btn.getAttribute('data-line');
        try {
          await fetch(getCartEndpoint('cart/change.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
          });
          await refreshShopifyCart();
        } catch (err) {
          console.error('Error removing item from cart:', err);
        }
      });
    });
  }

  // Handle Add to Cart Form
  const productForm = document.getElementById('mt-product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const addBtn = productForm.querySelector('.mt-add-cart-btn');
      const originalText = addBtn ? addBtn.textContent : '';

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'AÑADIENDO...';
      }

      const variantId = variantInput ? variantInput.value : '1';

      if (!isShopifyEnvironment()) {
        // Local preview simulation
        setTimeout(() => {
          const existing = localCart.find(i => i.id === variantId);
          if (existing) {
            existing.quantity += 1;
          } else {
            localCart.push({ id: variantId, quantity: 1 });
          }
          saveLocalCart();
          renderLocalCart();
          openCart();
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = originalText;
          }
        }, 300);
        return;
      }

      // Live Shopify AJAX Add
      const formData = new FormData(productForm);
      try {
        const response = await fetch(getCartEndpoint('cart/add.js'), {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          await refreshShopifyCart();
          openCart();
        } else {
          productForm.submit();
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        productForm.submit();
      } finally {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = originalText;
        }
      }
    });
  }

  // Bottom CTA Add Cart Button
  const bottomAddBtn = document.getElementById('MtBottomAddCartBtn');
  if (bottomAddBtn && productForm) {
    bottomAddBtn.addEventListener('click', () => {
      productForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  // Handle "COMPRA AHORA" (Buy Now Direct Checkout)
  const buyNowBtn = document.querySelector('.mt-buy-now-btn');
  if (buyNowBtn && productForm) {
    buyNowBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const originalHtml = buyNowBtn.innerHTML;
      buyNowBtn.innerHTML = '<span>PROCESANDO...</span>';

      const variantId = variantInput ? variantInput.value : '1';

      if (!isShopifyEnvironment()) {
        // Local preview simulation: add to local cart and redirect to checkout
        const existing = localCart.find(i => i.id === variantId);
        if (existing) existing.quantity += 1;
        else localCart.push({ id: variantId, quantity: 1 });
        saveLocalCart();
        window.location.href = '/checkout';
        return;
      }

      // Live Shopify direct add & checkout redirect
      const formData = new FormData(productForm);
      try {
        await fetch(getCartEndpoint('cart/add.js'), {
          method: 'POST',
          body: formData
        });
        window.location.href = getCartEndpoint('checkout');
      } catch (err) {
        window.location.href = getCartEndpoint('checkout');
      } finally {
        buyNowBtn.innerHTML = originalHtml;
      }
    });
  }

  // Checkout button handler in preview drawer
  document.querySelectorAll('[data-checkout-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      window.location.href = getCartEndpoint('checkout');
    });
  });

  // Initial setup on load
  if (!isShopifyEnvironment()) {
    renderLocalCart();
  } else {
    bindCartDrawerEvents();
  }
});
